"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const common_utils_1 = require("@zapier/common-utils");
const prettyType_1 = __importDefault(require("./prettyType"));
const isValidTypeOf = (template, index) => {
    if (!template.type_of) {
        return true;
    }
    return ((index === 0 && template.type_of === 'read') ||
        (index > 0 && template.type_of !== 'read' && prettyType_1.default(template.type_of)));
};
const nodeTemplatesFromQuery = (query = {}, { allowSparseNodes = false } = {}) => {
    const unflatQuery = common_utils_1.unflatten(query);
    const instructions = lodash_1.default.merge(unflatQuery.template, unflatQuery.steps);
    const nodeTemplates = Object.keys(instructions)
        .filter(key => !isNaN(parseInt(key)))
        .reduce((result, key) => {
        const numericKey = Number(key);
        result[numericKey] = instructions[key];
        return result;
    }, []);
    if (nodeTemplates.length === 0) {
        return null;
    }
    if (nodeTemplates.length > 50) {
        throw new Error('Templates cannot have more than 50 steps.');
    }
    if (!allowSparseNodes &&
        lodash_1.default.compact(nodeTemplates).length !== nodeTemplates.length) {
        throw new Error('Templates cannot have missing steps.');
    }
    return nodeTemplates.map((template, index) => {
        if (!isValidTypeOf(template, index)) {
            throw new Error(`Invalid type_of for node at index ${index}.`);
        }
        const safeTemplate = lodash_1.default.pick(template, [
            'title',
            'type_of',
            'selected_api',
            'action',
            'params',
            'meta',
        ]);
        safeTemplate.meta = lodash_1.default.pick(safeTemplate.meta || {}, ['parammap']);
        const defaultTypeOf = template.type_of || (index === 0 ? 'read' : 'write');
        return Object.assign(Object.assign({}, safeTemplate), { type_of: defaultTypeOf });
    });
};
exports.default = nodeTemplatesFromQuery;
